import { Heading } from '@campgladiator/cgui-core.atoms.typography'
import classNames from 'classnames'
import { ScheduleProps } from '../../TrainerBio.d'
import { OutdoorLocations } from '../OutdoorLocations'
import { VirtualWorkouts } from '../VirtualWorkouts'
import styles from './Schedule.module.scss'

const Schedule = ({
  className,
  isDesktop,
  isTabletSmall,
  workoutSchedule,
  ...props
}: ScheduleProps) => (
  <div className={classNames(styles.wrapper, className)} {...props}>
    <Heading type="h4" className={styles.title}>
      My Workout Schedule
    </Heading>
    {workoutSchedule.outdoor_schedule && (
      <OutdoorLocations
        className={styles.section}
        isDesktop={isDesktop}
        locations={workoutSchedule.outdoor_schedule}
      />
    )}
    {workoutSchedule.virtual_schedule && (
      <VirtualWorkouts
        className={styles.section}
        isTabletSmall={isTabletSmall}
        workouts={workoutSchedule.virtual_schedule}
      />
    )}
  </div>
)

export default Schedule
